import React, { forwardRef } from 'react';
import { Button as HeroButton } from '@heroui/react';

export interface ButtonProps {
  children: React.ReactNode;
  variant?:
    | 'solid'
    | 'faded'
    | 'shadow'
    | 'bordered'
    | 'light'
    | 'flat'
    | 'ghost';
  color?: 'default' | 'primary' | 'danger' | 'success' | 'warning';
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  size?: 'sm' | 'md' | 'lg';
  isDisabled?: boolean;
  isLoading?: boolean;
  isIconOnly?: boolean;
  fullWidth?: boolean;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = 'solid',
      color = 'primary',
      radius = 'md',
      size = 'md',
      isDisabled = false,
      isLoading = false,
      isIconOnly = false,
      fullWidth = false,
      startContent,
      endContent,
      onClick,
      className,
      type = 'button',
      ...rest
    },
    ref,
  ) => {
    return (
      <HeroButton
        ref={ref}
        variant={variant}
        color={color}
        radius={radius}
        size={size}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isIconOnly={isIconOnly}
        fullWidth={fullWidth}
        startContent={startContent}
        endContent={endContent}
        onClick={onClick}
        type={type}
        className={`${className} gap-1`}
        {...rest}
      >
        {children}
      </HeroButton>
    );
  },
);

Button.displayName = 'Button';

export default Button;
